export default String.raw`
{% assign blogPostsSize = blog.LatestPosts | Size -%}
{% if blogPostsSize > 0 -%}
    <section class="news">
        <div class="news__header">
            <h2>{{ translations.TheNewestArticles }}</h2>
            <a href="{{ page.BaseHref }}_/23">
                {{ translations.ShowAll }}
                <svg><use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use></svg>
            </a>
        </div>
        <div class="news__container">
            <div class="news__arrows">
                <button aria-label="{{translations.PrevSlide}}" class="news__arrows-prev arrow shadowed">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </button>
                <button aria-label="{{translations.NextSlide}}" class="news__arrows-next arrow shadowed">
                    <svg class="arrow__icon">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </button>
            </div>
            <div class="news__swiper" tabindex="-1">
                <div class="swiper-wrapper news__wrapper">
                    {% for post in blog.LatestPosts -%}
                        <div class="swiper-slide news__slide">
                            {% include 'partials/blog/blog-item.html' with post %}
                        </div>
                    {% endfor -%}
                </div>
            </div>
        </div>
    </section>
{% endif -%}
`